// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1tNtI","navItems":"footer_navItems___-hj5","navItem":"footer_navItem__1aE8B"};